import styled from '@mui/material/styles/styled'

export const Divider = styled('div', {
  name: 'Divider',
  slot: 'Root',
  skipSx: true,
})`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`
